module.exports = __webpack_public_path__ + "static/media/accessory34.28f53c8e.webp";